'use client'
import styled from "styled-components";
import TipIcon from "@/assets/icons/iconresult.svg";
import ArrowIcon from "@/images/icon/arrow-default.svg";
import UKDialog from "@/components/UKDialog";
import { DialogTitle, DialogContent } from "@mui/material"
import { useState } from "react";
import CDNImage from "../cdnImage/cdnImage";
const AgeVerificationWrapper = styled.div`
margin-bottom: 16px;
padding: 12px;
background: rgba(247, 248, 252, 1);
border-radius: 8px;
header {
    position: relative;
    line-height: 20px;
    color: #1A1A1A;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    gap: 2px;
    align-items: center;
    cursor: pointer;
    img {
        width: 20px;
        height: 20px;
        object-fit: cover;
    }
    &:hover {
        .arrow-right {
           path {
                stroke: var(--dp-hover-state-color);
            }
        }
       
    }
    .arrow-right {
        position: absolute;
        right: 0;
        transform: rotate(-90deg);

    }
}
.content {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #E0E1E5;
    line-height: 18px;
    color: #888B94;
    font-size: 14px;
}
`

const DialogContentWrapper = styled.div`
.dialog-content {
    font-size: 14px;
    margin-bottom: 32px;
}
.dialog-btn-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 4px;
    .confirm {
        width: 80px;
        line-height: 32px;
        background: var(--sys-color-Primary700);
        text-align: center;
        font-size: 14px;
        color: #fff;
        border-radius: 4px;
        cursor: pointer;
    }
}
`
const AgeVerificationDialog = ({isOpen, onClose, data}: any)=> {
    const {title, content} = data || {}
    return  <UKDialog open={isOpen} onClose={onClose} showCloseBtn={true} sx={{
        "& .MuiDialog-paper": {
            width: "520px",
            margin: "0",
            borderRadius: "12px",
        },
        '& .MuiDialogTitle-root': {
          fontSize: "16px",
          fontWeight: "bold",
          lineHeight: "20px",
          padding: "20px 24px 12px 24px",
        },
      }}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent sx={{}}>
      <DialogContentWrapper>
        <div className="dialog-content" dangerouslySetInnerHTML={{__html: content}}></div>
        <div className="dialog-btn-wrapper" >
            <div className="confirm" onClick={onClose}>
                OK
            </div>
        </div>
      </DialogContentWrapper>
    </DialogContent>
  </UKDialog>
}
export default function AgeVerification ({ data }: any) {
    const [open, setOpen] = useState<boolean>(false);
    const { 
        title,
        icon,
        shortText,
        detailText
    } = data || {}
    if(!title) { 
        return null
    }
    return <AgeVerificationWrapper>
        <header onClick={()=> setOpen(true)}>
            <CDNImage src={icon} width={30} height={30} alt="icon"/>
            {title}
            <ArrowIcon className="arrow-right"/>
        </header>
        <section className="content">
            {shortText}
        </section>
        <AgeVerificationDialog
         isOpen={open}
         onClose={()=> setOpen(false)}
         data={{
            title,
            content: detailText
         }}
        />
    </AgeVerificationWrapper>
}
